module.exports = __webpack_public_path__ + "img/twitter-logo.e737ac34.svg";